import { connect } from 'react-redux'
import NumbersEdit from './NumbersEdit'
import { getCallUsage, getNumber } from 'features/Numbers/Numbers.actions'
import showNumbersCallPlanModal from 'features/Numbers/NumbersCallPlanModal'
import showNumbersEnableFlowsModal from 'features/Numbers/NumbersEnableFlowsModal'
import showNumbersDisconnectModal from 'features/Numbers/NumbersDisconnectModal'
import showNumbersChangeUsagePlanModal from 'features/Numbers/NumbersChangeUsagePlanModal'
import showCasesCreateTroubleTicket from 'features/Cases/CasesCreateTroubleTicket'
import { getFlows } from 'features/Flows/Flows.actions'
import { get } from 'lodash'
import { submit } from 'redux-form'
import showFlowCreateModal from 'features/Flows/FlowCreateModal'

const stateToProps = ({ numbers, form, flows, auth }, { routeParams: { serviceId } }) => {
  const service = numbers.numbersById[serviceId] || {}
  const linkedCallFlow = flows.flowsById[service.twilioCallFlowId]
  const linkedSmsFlow = flows.flowsById[service.twilioSmsFlowId]

  const isAdmin = auth.user.roles?.includes('ROLE_API_ADMIN') || auth.adminToken || false

  return {
    service,
    linkedService: (service && numbers.numbersById[service.twilioFlowServiceId]) || {},
    savePending: get(form, 'numberEdit.submitting', false),
    linkedCallFlow,
    linkedSmsFlow,
    isAdmin,
    serviceId,
  }
}

const dispatchToProps = {
  getCallUsage,
  getNumber,
  showNumbersCallPlanModal,
  showNumbersDisconnectModal,
  showCasesCreateTroubleTicket,
  showNumbersEnableFlowsModal,
  showFlowCreateModal,
  showNumbersChangeUsagePlanModal,
  submit,
  getFlows,
}

export default connect(stateToProps, dispatchToProps)(NumbersEdit)



// WEBPACK FOOTER //
// ./src/pages/NumbersEdit/NumbersEdit.container.js